document.addEventListener('DOMContentLoaded', function () {
  document.querySelector('.sticky-information-bar .selector-title').addEventListener('click', function () {
    const dropdown = document.querySelector('.sticky-information-bar .variant-dropdown');
    const icon = document.querySelector('.sticky-information-bar .icon-chevron-down-thin');
    const selector = document.querySelector('.sticky-information-bar .selector-variants');

    const isVisible = dropdown.style.display === 'block';
    dropdown.style.display = isVisible ? 'none' : 'block';
    icon.classList.toggle('rotate', !isVisible);
    selector.classList.toggle('open', !isVisible);
  });

  document.querySelector('.sticky-information-bar .drag-handle').addEventListener('click', () => {
    const selector = document.querySelector('.sticky-information-bar .selector-variants');
    const dropdown = document.querySelector('.sticky-information-bar .variant-dropdown');
    const icon = document.querySelector('.sticky-information-bar .icon-chevron-down-thin');

    const isVisible = dropdown.style.display === 'block';
    icon.classList.toggle('rotate', !isVisible);
    dropdown.style.display = isVisible ? 'none' : 'block';
    selector.classList.toggle('open');
  });

})
